// frontend/src/pages/DashboardLayout.js

import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";

function DashboardLayout() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("isAuthenticated");
    navigate("/"); // Navega para a página de login
  };

  return (
    <div className="flex">
      <Sidebar handleLogout={handleLogout} />
      <main className="flex-grow p-8 bg-gray-100 h-screen overflow-y-auto">
        {/* O Outlet é onde as páginas aninhadas (lista, criar, etc.) serão renderizadas */}
        <Outlet />
      </main>
    </div>
  );
}

export default DashboardLayout;